// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  escrowId: __t.u64().primaryKey().name("escrow_id"),
  txId: __t.u64().name("tx_id"),
  payer: __t.identity(),
  payee: __t.identity(),
  amountSov: __t.i64().name("amount_sov"),
  releaseAt: __t.timestamp().name("release_at"),
  state: __t.string(),
});
